import { SummarizerConfig } from '../../types/summarizer';
import PDFInputSection from '../../components/summarizer/custom/PDFInputSection';

export const pdfSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'pdf-summarizer',
  title: 'Instant PDF Summarizer with AI',
  description: 'Get quick summaries in any language.',
  outputTitle: 'PDF Document Summary',
  version: '1.0.0',

  // Categorization
  category: 'document',
  tags: ['pdf', 'document', 'research', 'academic'],

  // Input configuration
  inputs: {
    file: {
      enabled: true,
      acceptedTypes: ['.pdf'],
      maxSize: 50 * 1024 * 1024, // 50MB in bytes
      placeholder: 'Upload your PDF document',
      multiple: false,
      helpText:
        'Upload PDF files up to 50MB. Get comprehensive summaries, key insights, and ask questions about your documents.',
      showHelpText: true,
    },
    url: {
      enabled: false, // PDF summarizer uses file upload only
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true, // PDFs don't have transcripts
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'pdf',
    timeout: 90000, // 90 seconds for large PDF processing
  },

  // UI customization (Level 1: Basic styling)
  ui: {
    primaryColor: '#dc2626',
    secondaryColor: '#b91c1c',
    icon: '📄',
    theme: 'light',
    // Custom loading messages for PDF content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is processing your PDF document...',
        subtitle:
          'Analyzing document structure, extracting key information, and creating insights.',
      },
      translation: {
        title: 'Translating document summary to {language}...',
        subtitle: 'Converting your PDF summary to the selected language.',
      },
      streaming: {
        indicator: 'Processing document content...',
      },
    },
    // Custom input component for PDF-specific design
    customComponents: {
      input: PDFInputSection,
    },
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 1024, // 1KB minimum
    maxSize: 50 * 1024 * 1024, // 50MB in bytes
    allowedDomains: [],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
